/**
 * Corp (PG Corp / Howl Tools) top nav configuration — GIK-11069.
 *
 * The bar links back out to the PG Corp portal. Every destination is an
 * external, full-page navigation (the user leaves the Give InKind SPA), so
 * these are rendered as plain `<a>` anchors, never the in-app `Link`.
 *
 * TODO(GIK-11069): confirm the real portal base URL and paths with Nele /
 * design / PG Corp. Values below are approximations from the Figma screenshots
 * and are intentionally centralised here so they are trivial to correct.
 */

/** Base URL of the PG Corp portal. TODO: confirm exact host. */
export const CORP_PORTAL_BASE_URL = 'https://corporate.perfectgift.com';

export interface CorpNavLink {
  /** Visible label. */
  label: string;
  /** Absolute destination on the Corp portal. */
  href: string;
  /**
   * Rendered in the active/current state. Give InKind lives under the Corp
   * portal's "Howl Tools" section, so that link is always shown active here.
   */
  active?: boolean;
}

/** Primary navigation links (Figma: "Merchant", "Howl Tools"). */
export const corpNavLinks: readonly CorpNavLink[] = [
  { label: 'Merchant', href: `${CORP_PORTAL_BASE_URL}/merchant` },
  { label: 'Howl Tools', href: `${CORP_PORTAL_BASE_URL}/howl-tools`, active: true },
];

/**
 * Account actions shown on the right (Figma signed-out variant + mobile
 * drawer): "Log In" and "Get Started". The Corp-signed-in variant (search /
 * cart / username) is intentionally not built — it needs Corp-session data
 * Give InKind does not have. See dev-notes "Open questions".
 */
export const corpLogInLink: CorpNavLink = {
  label: 'Log In',
  href: `${CORP_PORTAL_BASE_URL}/login`,
};

export const corpGetStartedLink: CorpNavLink = {
  label: 'Get Started',
  href: `${CORP_PORTAL_BASE_URL}/get-started`,
};

/** Where the two brand marks (Wolfe wordmark, perfectgift tab) link to. */
export const corpHomeHref = CORP_PORTAL_BASE_URL;
